window.config = window.config || {};

if (typeof config !== 'undefined') {
    Object.assign(window.config, config);
}

// Konfiguracja obrazków
window.config.images = {
    topBackgroundCard: `${window.config.link}/dist/images/home-04-bg.png`
};

window.config.icons = {
    plus: `${window.config.link}/dist/icons/plus.svg}`
};

// Zabezpieczenie przed nadpisaniem
Object.freeze(window.config);
Object.freeze(window.config.images);
